module.exports = __webpack_public_path__ + "img/4.c16f6061.jpg";